import { render, staticRenderFns } from "./supplierBudgetAdjustDetail.vue?vue&type=template&id=0630a03b&"
import script from "./supplierBudgetAdjustDetail.vue?vue&type=script&lang=js&"
export * from "./supplierBudgetAdjustDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports